import * as service from './service'
export default {
  namespace: 'ForceSurvey',
  state: {
    surveyData: {}
  },
  effects: {
    * saveSurvey ({ payload }, { call, put }) {
      const res = yield call(service.saveSurvey, payload)
      yield put({
        type: 'save',
        payload: {
          surveyData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
